var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-card', {
    attrs: {
      "loader": _vm.loader
    }
  }, [_c('div', {
    slot: "header"
  }, [_c('div', {
    directives: [{
      name: "padding",
      rawName: "v-padding.left",
      value: (3),
      expression: "3",
      modifiers: {
        "left": true
      }
    }, {
      name: "padding",
      rawName: "v-padding.right",
      value: (3),
      expression: "3",
      modifiers: {
        "right": true
      }
    }, {
      name: "padding",
      rawName: "v-padding.top",
      value: (2),
      expression: "2",
      modifiers: {
        "top": true
      }
    }, {
      name: "padding",
      rawName: "v-padding.bottom",
      value: (2),
      expression: "2",
      modifiers: {
        "bottom": true
      }
    }]
  }, [_c('div', [_c('v-text', {
    attrs: {
      "nowrap": "",
      "type": "title"
    }
  }, [_vm._v("\n                        Лицензионное соглашение\n                    ")])], 1), _vm._v(" "), _c('div', [_c('v-text', {
    attrs: {
      "type": "subheadling"
    }
  }, [_vm._v("\n                        Используя сервис, вы соглашаетесь с\n                        "), _c('v-text', {
    attrs: {
      "nowrap": ""
    }
  }, [_c('v-link', {
    attrs: {
      "size": "subheadling",
      "to": "https://exbico.ru/oferta_und",
      "target": "_blank"
    }
  }, [_vm._v("\n                                лицензионным соглашением\n                            ")])], 1)], 1)], 1)])])])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5841c7a4","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/home/contractPaper/ContractPaper.vue
// module id = 918
// module chunks = 0